/**
 * Resolve heivol design-system tokens to concrete colours for recharts (SVG needs real
 * colour strings, not CSS vars for some computed paths). Re-read on theme change so charts
 * follow the ◐ toggle.
 */
export interface ChartColors {
  ai: string;
  aiSurface: string;
  chat: string;
  success: string;
  warning: string;
  grid: string;
  axis: string;
  surface: string;
  border: string;
  text: string;
}

function cssVar(name: string, fallback: string): string {
  if (typeof window === 'undefined') return fallback;
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v || fallback;
}

export function chartColors(): ChartColors {
  return {
    ai: cssVar('--hv-ai', '#e11d48'),
    aiSurface: cssVar('--hv-ai-surface', '#fff1f2'),
    chat: cssVar('--hv-chat', '#c7432b'),
    success: cssVar('--hv-success', '#059669'),
    warning: cssVar('--hv-warning', '#d97706'),
    grid: cssVar('--hv-border', '#e2e8f0'),
    axis: cssVar('--hv-text-tertiary', '#8b95a5'),
    surface: cssVar('--hv-surface', '#ffffff'),
    border: cssVar('--hv-border', '#e2e8f0'),
    text: cssVar('--hv-text', '#2d3748'),
  };
}
